import React from 'react';
import { usePage } from '@inertiajs/react';
import {
    DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel,
    DropdownMenuTrigger,
} from './ui/dropdown-menu';
import { useTrans } from '../hooks/useTrans';

export default function LanguageSwitcher({ onSwitch }) {
    const translate = useTrans();
    const { locale, locales } = usePage().props;

    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild>
                <button className="flex items-center h-16 px-4 cursor-pointer focus:outline-none">
                    <span className={`sprite sprite--${locales[locale]?.flag} ring-1 ring-white`}></span>
                </button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="min-w-[180px] bg-[#003545] border-none rounded-[2px] p-0">
                <DropdownMenuLabel className="bg-[#022833] p-3 text-[14px] font-bold text-white">
                    {translate('Taal')}
                </DropdownMenuLabel>
                {Object.entries(locales).map(([key, loc]) => (
                    <DropdownMenuItem
                        key={key}
                        onClick={() => onSwitch(key)}
                        className="flex cursor-pointer items-center gap-2 px-3 py-2 text-[14px] text-white focus:bg-[#022833] focus:text-white"
                    >
                        <span className={`sprite sprite--${loc.flag}`}></span>
                        {loc.title}
                    </DropdownMenuItem>
                ))}
            </DropdownMenuContent>
        </DropdownMenu>
    );
}
